import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

if ('serviceWorker' in navigator && (import.meta as any).env.PROD) {
  window.addEventListener('load', () => {
    const appBundle = new URL(import.meta.url).pathname.split('/').pop() || 'app';
    navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(appBundle)}`, { updateViaCache: 'none' }).catch(error => {
      console.warn('Service worker registration failed', error);
    });
  });
}
